import { useMutation } from '@tanstack/react-query';
import { getRevisions } from '../queries';
import { practiceRevisionStore } from '../stores/practiceRevisionStore';

export function useGetPracticeRevision() {
  const { setPracticeRevision } = practiceRevisionStore();

  const { mutate, data, isPending, isError } = useMutation({
    mutationKey: ['getPracticeRevision'], 
    mutationFn: () => getRevisions(),
    onSuccess: (response) => {
      const reviews = response.revisions;
      setPracticeRevision(reviews)
    },
    retry: false
  });

  return { mutate, data, isPending, isError };
}
